import { useCallback, useRef, useState } from 'react';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { performGetRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { State } from './types';
import { getUrl, transformRestResponse } from './utils';

export const useSlaFieldsService = (baseUrl: BaseUrl): State => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [error, setError] = useState<unknown>();

	const abortController = useRef<unknown>(null);

	const fetch = useCallback(
		async (searchQuery: string) => {
			setError(null);

			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			if (abortController.current && abortController.current.abort) {
				// @ts-expect-error - TS2571 - Object is of type 'unknown'.
				abortController.current.abort();
			}

			try {
				abortController.current = new AbortController();
				// @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
				const { signal } = abortController.current;
				const response = await performGetRequest(
					getUrl(baseUrl, searchQuery),

					{
						method: 'GET',
						signal,
					},
				);
				fireTrackAnalytics(createAnalyticsEvent({}), 'slaFields fetched');
				return transformRestResponse(response);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				if (err && err.name === 'AbortError') {
					return undefined;
				}
				trackFetchErrors({
					error: err,
					id: 'useSlaFieldsService',
					packageName: 'jiraServicedeskSlaSettings',
				});
				setError(err);
			}

			return undefined;
		},
		[baseUrl, createAnalyticsEvent],
	);
	// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
	return [{ error }, { fetch }];
};
